import { Injectable } from '@angular/core'
import { DefaultProjectorFn, MemoizedSelector, Store } from '@ngrx/store'
import { firstValueFrom, Observable, take } from 'rxjs'

@Injectable({
    providedIn: 'root',
})
export class StoreUtilsService {
    constructor(private readonly store: Store) {}

    snapshotAsync<T>(selector: MemoizedSelector<object, T, DefaultProjectorFn<T>>): Promise<T> {
        return firstValueFrom(this.store.select(selector))
    }

    snapshotObservable<T>(
        selector: MemoizedSelector<object, T, DefaultProjectorFn<T>>
    ): Observable<T> {
        return this.store.select(selector).pipe(take(1))
    }
}
